import React, { useState } from "react";
import hosys from "@/api/api";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ExternalLink, Monitor, Check } from "lucide-react";
import { createPageUrl } from "@/utils";

const KIOSK_MODES = [
  { value: "both", label: "Ambdós (llista + PIN)", description: "El treballador pot entrar per nom o per PIN" },
  { value: "list", label: "Selecció per llista", description: "El treballador tria el seu nom d'una llista" },
  { value: "pin",  label: "PIN únicament",        description: "El treballador introdueix el seu PIN de 4 dígits" },
];

export default function KioskSettings({ venue, onUpdated }) {
  const [mode, setMode] = useState(venue?.kiosk_mode || "both");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const kioskUrl = venue?.id
    ? `${window.location.origin}${createPageUrl("Kiosk")}?venue_id=${venue.id}`
    : "";

  const save = async () => {
    setSaving(true);
    await hosys.entities.Venue.update(venue.id, { kiosk_mode: mode });
    setSaving(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
    if (onUpdated) onUpdated();
  };

  return (
    <div className="space-y-5">
      <div>
        <h3 className="font-semibold text-gray-800 mb-1">Configuració del kiosk</h3>
        <p className="text-xs text-gray-400">
          El kiosk és una pantalla pública que permet fitxar sense login. Idealment es posa en una tablet a l'entrada del local.
        </p>
      </div>

      {/* Mode selector */}
      <div>
        <label className="text-xs font-medium text-gray-500 mb-2 block">Mode de fitxatge</label>
        <Select value={mode} onValueChange={setMode}>
          <SelectTrigger className="w-full">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {KIOSK_MODES.map(m => (
              <SelectItem key={m.value} value={m.value}>
                {m.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <p className="text-xs text-gray-400 mt-1.5">
          {KIOSK_MODES.find(m => m.value === mode)?.description}
        </p>
      </div>

      <Button
        onClick={save}
        disabled={saving}
        size="sm"
        className="bg-[#7B2D3F] hover:bg-[#5B1D2F] text-white gap-2"
      >
        {saved ? <><Check className="w-4 h-4" /> Guardat</> : saving ? "Guardant..." : "Guardar configuració"}
      </Button>

      {/* Kiosk URL */}
      {venue?.id && (
        <div className="border border-gray-100 rounded-xl p-4 bg-gray-50">
          <div className="flex items-center gap-2 mb-2">
            <Monitor className="w-4 h-4 text-gray-400" />
            <p className="text-xs font-semibold text-gray-600">URL del kiosk</p>
          </div>
          <p className="text-xs text-gray-400 break-all font-mono bg-white border border-gray-100 rounded-lg px-3 py-2">
            {kioskUrl}
          </p>
          <a
            href={kioskUrl}
            target="_blank"
            rel="noreferrer"
            className="mt-2 inline-flex items-center gap-1.5 text-xs text-[#7B2D3F] font-medium hover:underline"
          >
            <ExternalLink className="w-3.5 h-3.5" /> Obrir kiosk en nova finestra
          </a>
          <p className="text-[10px] text-gray-400 mt-2">
            Copia aquesta URL i obre-la en pantalla completa a la tablet del local.
          </p>
        </div>
      )}
    </div>
  );
}